import { useState, useCallback } from 'react';

/**
 * React 18 compatible hook for managing slideout state
 * Provides a simple, consistent API for all slideouts
 */
export const useSlideout = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    open,
    close,
    toggle,
  };
};
